<div class="mct-flex mct-row mct-justify-between mct-items-stretch"  >
  <h4>{{ 'profiles.view.benefits.label' | translate | titlecase }}</h4>
  <div class="manage-all-link">
    <a (click)="manageBenefits()">{{ 'profiles.view.benefits.manage-all' | translate }}</a>
  </div>
</div>
<div *ngFor="let benefit of benefitSummary.ProfileBenefits">
  <div class="benefit-container mct-flex mct-row mct-wrap" >
    <div class="mct-basis-50" >
      <div class="benefit-name">
        {{ benefit.Benefit }}
      </div>
      <div class="card-field-label">
        {{ benefit.QuantityUsed }}
        {{ 'profiles.view.benefits.of' | translate }}
        {{ benefit.Quantity }}
        {{ 'profiles.view.benefits.benefits-used' | translate }}
      </div>
    </div>
    <div class="mct-basis-50" >
      <div class="mct-flex mct-row mct-justify-between mct-items-stretch"  >
        <div>{{ benefit.ValueUsed | currency }} {{ 'profiles.view.benefits.used' | translate }}</div>
        <div>{{ benefit.TotalValue | currency }} {{ 'profiles.view.benefits.total-value' | translate }}</div>
      </div>
      <div class="benefit-gauge">
        <div
          class="benefit-used-bar"
          [style.width]="(benefit.ValueUsed > 0 ? (benefit.ValueUsed / benefit.TotalValue) * 100 : 0) + '%'"
        ></div>
      </div>
    </div>
  </div>
</div>
